import { useEffect, useState } from 'react';

import { useQuestionnaireNavigation } from '@/context/NavigationProvider';
import { Button } from '@/components/ui/button';
import { PatientPageLayout } from '@/components/PatientPageLayout';
import { ResponseFileUploadField } from '@/components/ResponseFileUploadField';
import { ViewableResponse } from '@/types/global';
import { scrollToTop } from '@/util/scroll';

// Minimal response describing the catch-all slot: no documentKey (free-form),
// multiple files, both file-picker and camera.
const CATCH_ALL_RESPONSE = {
  documentMultipleAllowed: true,
  documentCaptureMethod: 'both',
} as ViewableResponse;

export const AdditionalDocumentUploadPage = () => {
  const { navigateNext } = useQuestionnaireNavigation();
  const [hasUploaded, setHasUploaded] = useState(false);

  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className="flex h-full flex-col">
      <PatientPageLayout
        title={
          <h1 className="text-2xl min-[23rem]:text-3.5xl font-semibold leading-tight nxs:text-center">
            Souhaitez-vous joindre des documents&nbsp;?
          </h1>
        }
        footer={
          <div className="mx-auto flex w-full max-w-[330px] flex-col items-center gap-4">
            <Button
              variant="ctaPrimary"
              size="lg"
              onClick={() => navigateNext()}
            >
              {hasUploaded ? 'Continuer' : 'Passer cette étape'}
            </Button>
          </div>
        }
      >
        <div className="flex flex-col items-center gap-4 px-2 text-sm font-light">
          <p className="w-full leading-5 nxs:text-center">
            Vous pouvez joindre tout document utile pour votre consultation
            (résultats d&apos;analyses, ECG, ordonnances…)
          </p>
          <ResponseFileUploadField
            response={CATCH_ALL_RESPONSE}
            onChange={(value) => setHasUploaded(Boolean(value))}
          />
        </div>
      </PatientPageLayout>
    </div>
  );
};
